import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetch3, fetch4 } from "../commonApis/commonApis";

const url = process.env.REACT_APP_BASE_URL;

export const useFetchPackagingData = (awb: string) => {
  return useQuery({
    queryKey: ["packagingData", awb],
    queryFn: async () => {
      if (!awb) return null;
      const res = await fetch3(`${url}/api/packaging/${awb}`, "get");
      return res.data;
    },
    enabled: !!awb,
    refetchInterval: false,
  });
};

export const useVerifyPackagingItem = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ awb, sku, qty, boxId }: { awb: string; sku: string; qty: number; boxId?: string | null }) => {
      const payload = { sku, qty, boxId };
      const res = await fetch4(`${url}/api/packaging/${awb}/verify`, payload);
      return res;
    },
    onSuccess: (_data, variables) => {
      // Invalidate to refresh scan logs and item counts
      queryClient.invalidateQueries({ queryKey: ["packagingData", variables.awb] });
      queryClient.invalidateQueries({ queryKey: ["orderOperations"] });
      queryClient.invalidateQueries({ queryKey: ["todayPackedStream"] });
    },
  });
};

export const useInstantScanAll = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ awb, boxId }: { awb: string; boxId?: string | null }) => {
      const payload = { boxId };
      const res = await fetch4(`${url}/api/packaging/${awb}/instant-scan-all`, payload);
      return res;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["packagingData", variables.awb] });
      queryClient.invalidateQueries({ queryKey: ["orderOperations"] });
      queryClient.invalidateQueries({ queryKey: ["todayPackedStream"] });
    },
  });
};

export const useFetchPackagingStaff = () => {
  return useQuery({
    queryKey: ["packagingStaff"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/packaging/today-stream/staff`, "get");
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchTodayPackedStream = (userId: string) => {
  return useQuery({
    queryKey: ["todayPackedStream", userId],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/packaging/today-stream/list?userId=${userId}`, "get");
      return res.data || [];
    },
    enabled: true,
    refetchInterval: 10000, // Auto-refresh every 10 seconds to keep live stream updated
  });
};

